import { defineMessages } from 'react-intl.macro';

import { DocTypeEnum } from '../../openapi/types/DocTypeEnum';

/**
 * Popisky dokladů IPR. Sdílí je datová objednávka i objednávka služby, id zůstávají
 * z původního umístění v `orderMessages`, aby nepřišly o překlady.
 */
export const iprDocumentMessages = defineMessages({
  sectionTitle: {
    id: 'orderDetail.iprDocuments.title',
    defaultMessage: 'Doklady',
  },
  downloadError: {
    id: 'orderDetail.iprDocuments.downloadError',
    defaultMessage: 'Doklad není k dispozici',
  },
  documentNote: {
    id: 'orderDetail.iprDocuments.documentNote',
    defaultMessage: 'č. {number}, vystaveno {issued, date, short}',
  },
});

export const iprDocTypeMessages = defineMessages<DocTypeEnum>({
  [DocTypeEnum.podklad_pro_fakturu]: {
    id: 'orderDetail.iprDocuments.podkladProFakturu',
    defaultMessage: 'Podklad pro fakturu',
  },
  [DocTypeEnum.danovy_doklad]: {
    id: 'orderDetail.iprDocuments.danovyDoklad',
    defaultMessage: 'Daňový doklad',
  },
  [DocTypeEnum.protokol_vydej_dat]: {
    id: 'orderDetail.iprDocuments.protokolVydejDat',
    defaultMessage: 'Protokol výdeje dat',
  },
});
